import React from 'react'
import { StyledPopper, StyledPaper } from './Popper.styles'

const PopperContainer = ({open, anchorEl, children}) => {
  return (
    <StyledPopper open={open} anchorEl={anchorEl}>
      <StyledPaper width={anchorEl?.clientWidth}>
        {children}
      </StyledPaper>
    </StyledPopper>
  )
}

export default PopperContainer
